import { render, staticRenderFns } from "./GoogleAuthComponent.vue?vue&type=template&id=0665b7de&scoped=true"
import script from "./GoogleAuthComponent.vue?vue&type=script&lang=ts"
export * from "./GoogleAuthComponent.vue?vue&type=script&lang=ts"
import style0 from "./GoogleAuthComponent.vue?vue&type=style&index=0&id=0665b7de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665b7de",
  null
  
)

export default component.exports